import React from 'react';
import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../../../components';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

function DynamicField({ answerCheckboxes }) {
  const { t } = useTranslation();

  return (
    <Form.List name='interview_questions_attributes'>
      {(fields, { add, remove }) => {
        return (
          <div>
            {fields.map((field, index) => (
              <div key={field.key}>
                <Card title={`Domanda n. ${index + 1}`}>
                  <Form.Item name={[index, 'title']}>
                    <Input placeholder={t('Inserisci testo')} />
                  </Form.Item>
                  <Row gutter={16}>
                    <Col span={4}>
                      <Form.Item
                        valuePropName='checked'
                        name={[index, 'is_input_text']}
                      >
                        <Checkbox>Domanda aperta</Checkbox>
                      </Form.Item>
                    </Col>
                    {!answerCheckboxes[index] && (
                      <>
                        <Col span={4}>
                          <Form.Item name={[index, 'question1']}>
                            <Input placeholder={t('Risposta') + ' 1'} />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item name={[index, 'question2']}>
                            <Input placeholder={t('Risposta') + ' 2'} />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item name={[index, 'question3']}>
                            <Input placeholder={t('Risposta') + ' 3'} />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item name={[index, 'question4']}>
                            <Input placeholder={t('Risposta') + ' 4'} />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item name={[index, 'question5']}>
                            <Input placeholder={t('Risposta') + ' 5'} />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>

                {fields.length > 1 ? (
                  <>
                    <br />
                    <Button
                      type={'red'}
                      className='dynamic-delete-button'
                      onClick={() => remove(field.name)}
                      icon={<MinusCircleOutlined />}
                    >
                      {t('Cancella domanda')}
                    </Button>
                    <br />
                  </>
                ) : null}
              </div>
            ))}
            {fields.length < 16 && (
              <Form.Item>
                <Divider />
                <Button onClick={() => add()} style={{ width: '60%' }}>
                  <PlusOutlined /> {t('Aggiungi domanda')}
                </Button>
              </Form.Item>
            )}
          </div>
        );
      }}
    </Form.List>
  );
}

const AnswerSection = ({ form, answerCheckboxes }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('RISPOSTA')}</Typography.Title>
      </Col>
      <Col span={18}>
        <DynamicField answerCheckboxes={answerCheckboxes} form={form} />
      </Col>
    </Row>
  );
};

export default React.memo(AnswerSection);
